import { render, staticRenderFns } from "./FormClaim.vue?vue&type=template&id=30a285db&scoped=true"
import script from "./FormClaim.vue?vue&type=script&lang=js"
export * from "./FormClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a285db",
  null
  
)

export default component.exports